<template>
    <div class="page bg-gray" :class="{'pb-fixed-btn':(entity.orderStatus == 2 && isManager != '1') || entity.orderStatus == 3 || entity.orderStatus == 7 || (entity.orderStatus == 8 && isFromScan && isManager != '1')}">
        <backTitleBar ref="backTitle"></backTitleBar>
        <div class="content">
            <div class="content-title">
                <div v-for="item in dicts['orderStatus']" :key="item.codeid" v-if="String(entity.orderStatus) == item.code">
                    <span>{{ item.codename }}</span>
                </div>
            </div>
            <div class="card mt-20" v-if="entity.userAddress && entity.userMobile">
                <div class="flex-center address-box">
                    <div class="alifont icon-dizhi"></div>
                    <div class="flex1">
                        <div class="fs-28 color-333">{{entity.userAddress}}</div>
                        <div class="flex fs-28 color-999 mt-5">
                            <div class="mr-30">{{entity.userName}}</div>
                            <div>{{entity.userMobile}}</div>
                        </div>
                    </div>
                </div>
                <div class="text-center fs-32 color-main pb-25 click mt-10" v-if="entity.orderStatus == 2" v-clipboard:copy="entity.userName +','+entity.userMobile + ',' + entity.userAddress" v-clipboard:success="onCopySuccess" v-clipboard:error="onCopyError">复制发货信息</div>
            </div>
            <div class="card mt-20" v-if="entity.shopInfo">
                <div class="flex-center address-box">
                    <div class="alifont icon-dianpupeizhi"></div>
                    <div class="flex1">
                        <div class="fs-28 color-333">{{entity.shopInfo.shopName}}</div>
                        <div class="flex fs-28 color-999 mt-5">
                            <div class="mr-30">{{entity.shopInfo.address}}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card mt-20 pd-025">
                <div class="product-item" v-for="(prod,prodIndex) in entity.productList" :key="prodIndex">
                    <div class="flex pd-250">
                        <div class="product-img"><img :src="prod.imgPathView" alt=""></div>
                        <div class="product-info flex1 ofh">
                            <div class="fs-28 color-000 name">{{prod.productName}}</div>
                            <div class="mt-15 fs-28 color-999">规格：{{prod.specName}}</div>
                            <div class="flex-between fs-28 color-999">
                                <div>销售价：¥{{prod.salePrice}}</div>
                                <div>x{{prod.productQty}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--v-if="entity.orderMessage"-->
                <div class="flex pd-250 fs-28 bd-top" >
                    <div class="color-999">留言</div>
                    <div class="color-333 ml-20">{{entity.remark}}</div>
                </div>
            </div>
            <div class="card mt-20 pd-025">
                <div class="show-info-box">
                    <div class="info-detail-item">
                        <div class="left">优惠</div>
                        <div class="right">-￥{{entity.useCouponAmount || 0}}</div>
                    </div>
                    <!--<div class="info-detail-item">-->
                        <!--<div class="left">平台优惠</div>-->
                        <!--<div class="right">无可用</div>-->
                    <!--</div>-->
                    <div class="info-detail-item">
                        <div class="left">运费</div>
                        <div class="right color-red">+￥{{entity.transportCosts || 0}}</div>
                    </div>
                </div>
                <div class="total">
                    <span class="fs-28 color-999">实付款</span>
                    <span class="fs-26 color-red">￥</span>
                    <span class="fs-36 color-red">{{entity.receivable}}</span>
                </div>
            </div>
            <div class="card mt-20 pd-025 mb-20">
                <div class="show-info-box bd-bot">
                    <div class="info-detail-item">
                        <div class="left">订单编号</div>
                        <div class="right flex">
                            <div>{{entity.orderNo}}</div>
                            <div class="ml-20 click color-main" v-clipboard:copy="entity.orderNo" v-clipboard:success="onCopySuccess" v-clipboard:error="onCopyError">复制</div>
                        </div>
                    </div>
                    <div class="info-detail-item">
                        <div class="left">下单时间</div>
                        <div class="right">{{entity.orderCommitTime}}</div>
                    </div>
                </div>
                <div class="show-info-box bd-bot">
                    <div class="info-detail-item">
                        <div class="left">下单人</div>
                        <div class="right">{{entity.nickname}}</div>
                    </div>
                    <div class="info-detail-item">
                        <div class="left">下单账户</div>
                        <div class="right"></div>
                    </div>
                    <div class="info-detail-item">
                        <div class="left">支付方式</div>
                        <div class="right">
                            <div v-for="item in dicts['payChannel']" :key="item.codeid" v-if="String(entity.payType) == item.code">
                                <span :class="item.code == 1? 'blue':'green'">{{ item.codename }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="info-detail-item">
                        <div class="left">支付时间</div>
                        <div class="right">{{entity.payTime}}</div>
                    </div>
                </div>
                <div class="show-info-box" v-if="entity.userAddress && entity.userMobile">
                    <div class="info-detail-item">
                        <div class="left">配送方式</div>
                        <div class="right">快递配送</div>
                    </div>
                    <div class="info-detail-item" v-if="entity.dmName">
                        <div class="left">配送员</div>
                        <div class="right">{{entity.dmName}}</div>
                    </div>
                    <div class="info-detail-item" v-if="entity.dmMobile">
                        <div class="left">配送员手机号</div>
                        <div class="right">{{entity.dmMobile}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="fixed-bot" v-if="entity.orderStatus == 2 && isManager != '1'">
            <div class="btn click" @click="sendOrderFun()">发货</div>
        </div>
        <div class="fixed-bot" v-if="entity.orderStatus == 3 || entity.orderStatus == 7">
            <div class="btn click" @click="deliverOrder">已送达</div>
        </div>
        <div class="fixed-bot" v-if="entity.orderStatus == 8 && isFromScan && isManager != '1'">
            <div class="btn click" @click="checkOrderFun">核销</div>
        </div>

        <van-action-sheet v-model="actionsSheetShow" :actions="actions" cancel-text="取消" close-on-click-action description="请选择发货类型" @select="onSelect" />

    </div>
</template>

<script>
    import backTitleBar from "@/components/titleBar/backTitleBar"
    import {getOrderDetail,batchUpdateOrderStatus} from "@/api/order"
    import {checkOrder} from "@/api/shop"
    import initDict from "@/mixins/initDict"
    export default {
        name: "orderDetail",
        components:{backTitleBar},
        mixins:[initDict],
        data(){
            return{
                entity:{},
                isFromScan:false,
                shopId: this.$store.state.user.shopId,
                actionsSheetShow:false,
                isManager:'0',
                actions:[],
                actionsByJishida: [{ name: '同城快递', subname: '达达、美团' }, { name: '自营物流' }],
                actionsByOnlineShop: [{ name: '普通快递',  subname: '需填写物流信息' }, { name: '同城快递', subname: '达达、美团' },{ name: '跳过填写物流',subname: '此操作直接更改订单状态为待收货' }],
            }
        },
        created(){
            // 加载数据字典
            let codeList = [
                'express_type',
                'payChannel',
                'orderStatus'
            ]
            this.getThisDict(codeList)

            this.orderId = this.$route.query.orderId;
            this.isFromScan = this.$route.query.isScan || false;
            this.isManager =  this.$route.query.isManager;
            this.getDetail();
        },
        methods:{
            back(){
                if(this.isBackClose){
                    try{
                        window.native.onFinish();
                    }catch (e) {

                    }
                }else{
                    try{
                        window.native.onBack();
                    }catch (e) {
                        this.$router.go(-1)
                    }
                }
            },
            getDetail(){
                getOrderDetail(this.orderId).then(res=>{
                    if(res.data){
                        this.entity = res.data;
                    }else{
                        let _this = this;
                        this.$dialog.alert({
                            title: "提示",
                            message: "查询不到该订单信息，请核对订单！",
                            showCancelButton: false
                        })
                            .then(() => {     //点击确认按钮后的调用
                                _this.$refs.backTitle.back();
                            })
                            .catch(() => { //点击取消按钮后的调用
                                console.log("cancel")
                            })
                    }

                })
            },
            onCopySuccess(){
                this.$toast("复制成功");
            },
            onCopyError(){
                this.$toast("复制失败");
            },
            //核销订单
            checkOrderFun(){
                let params = {
                    shopId:this.shopId,
                    orderId: this.entity.orderId
                }
                checkOrder(params).then(res=>{
                    this.$toast('核销成功');
                    this.getDetail();
                })
            },


            sendOrderFun(){
                //订单类型为及时达
                if(this.entity.orderType == 10){
                    this.actions = this.actionsByJishida;
                    this.actionsSheetShow = true
                }else{
                    this.actions = this.actionsByOnlineShop;
                    this.actionsSheetShow = true
                }
            },

            //选择动作面板回调
            onSelect(item) {
                let name = item.name;
                let _this = this;
                switch (name) {
                    case '同城快递':
                        _this.sendOrderAjax(1,'确定此订单同城快递发货（通知达达或美团收件）？')
                        break;
                    case '自营物流':
                        _this.sendOrderAjax(0,'确定此订单自营物流发货（跳过通知物流直接更新状态）？')
                        break;
                    case '普通快递':
                        _this.actionsSheetShow = false;
                        _this.$router.push({name:'sendOrder',query:{orderId: _this.entity.orderId}})
                        break;
                    case '跳过填写物流':
                        _this.sendOrderAjax(0,'确定此订单发货（跳过填写物流直接更新状态）？')
                        break
                }
            },

            sendOrderAjax(deliveryType,msg){
                //deliveryType  配送方式 0自营配送 1物流配送
                let _this = this;
                let array = this.selectOrderList;
                this.$dialog.alert({
                    title: "提示",
                    message: msg || "确定此订单发货？",
                    showCancelButton: true
                }).then(() => {     //点击确认按钮后的调用
                    let params = {
                        orderIds: _this.entity.orderId,
                        orderStatus: 3,
                        deliveryType: deliveryType
                    }
                    batchUpdateOrderStatus(params).then(res=>{
                        _this.$toast('操作成功');
                        _this.$store.state.updateOrderList = true;
                        _this.back();
                    })
                }).catch(() => { //点击取消按钮后的调用
                    console.log("cancel")
                })
            },

            // 已送达
            deliverOrder(){
                let _this = this;
                this.$dialog.alert({
                    title: "提示",
                    message: "确定此订单已送达？",
                    showCancelButton: true
                })
                    .then(() => {
                        let params = {
                            orderIds: _this.entity.orderId,
                            orderStatus: 1
                        }
                        batchUpdateOrderStatus(params).then(res=>{
                            _this.$toast('操作成功');
                            _this.$store.state.updateOrderList = true;
                            _this.back();
                        })
                    })
                    .catch(() => {
                        console.log("cancel")
                    })
            },
        }
    }
</script>

<style scoped lang="scss">
    .content{
        padding: 0 .24rem;
        .content-title{
            padding-top: .32rem;
            font-size: .46rem;
            line-height: .65rem;
            color: #000;
            font-weight: bold;
        }
    }
    .address-box{
        padding: .24rem 0;
        .alifont{
            font-size: .68rem;
            color: #FF3232;
            margin-right: .1rem;
        }
    }
    .product-img{
        width: 1.7rem;
        height: 1.72rem;
        margin-right: .24rem;
    }
    .name{
        height: .8rem;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
    }
    .total{
        padding: 0 0 .24rem 0;
        text-align: right;
    }
</style>



// WEBPACK FOOTER //
// orderDetail.vue?7f59f3d6